import { Card, CardContent, Typography } from '@material-ui/core';
import React from 'react'
import './InfoBox.css'

function InfoBox({title, cases, total, ...props}) {
    return (
        <Card onClick={props.onClick} className={`infoBox ${props.active && "infobox--selected"} ${props.isGreen && "green"}`}>
            <CardContent>
                <Typography className={`infoBox__title ${props.isGreen}`} color="textSecondary">
                    {title}
                </Typography>
                <h2 className={`infoBox__cases ${props.isGreen && "title--recovered"}`}>{cases}</h2>
                <Typography className="infoBox__total" color="textSecondary">
                    {total} Total
                </Typography>
            </CardContent>
        </Card>
    )
}

export default InfoBox
